import React from 'react';
import { mediaUrl } from '../../../utils/mediaUrl';
import { logEvent } from '../../../utils/analytics';

const VideoMessage = ({ message, avatarSrc, memberId }) => {
  const { videoPath, timestamp } = message;
  const avatarUrl = mediaUrl(avatarSrc);

  return (
    <div className="message">
      <img
        className="avatar"
        src={avatarUrl || undefined}
        alt="成員頭像"
        onError={(e) => {
          e.target.onerror = null;
          e.target.removeAttribute('src');
        }}
      />
      <div className="message-content">
        <div className="message-text video-container">
          {videoPath && (
            <video
              controls
              className="message-video"
              onPlay={() => logEvent('media_view', { media_type: 'video', member_id: memberId })}
            >
              <source src={mediaUrl(videoPath)} type="video/mp4" />
              您的瀏覽器不支援視訊播放
            </video>
          )}
        </div>
        <div className="timestamp">{timestamp}</div>
      </div>
    </div>
  );
};

export default VideoMessage;